import { render, staticRenderFns } from "./ReceivedOrderDetail.vue?vue&type=template&id=2c1f5e7c&scoped=true"
import script from "./ReceivedOrderDetail.vue?vue&type=script&lang=js"
export * from "./ReceivedOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceivedOrderDetail.vue?vue&type=style&index=0&id=2c1f5e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f5e7c",
  null
  
)

export default component.exports